import {CdkDrag, CdkDropList, CdkDragHandle} from '@angular/cdk/drag-drop';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  EmButtonModule,
  EmErrorBoxModule,
  EmIconModule,
  EmInfoBoxModule,
  EmInputModule,
  EmSpinnerModule,
  EmWarningBoxComponent,
} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';
import {EmMappingRuleListModule} from '../mapping-rule-list/mapping-rule-list.module';
import {EmReadableMappingRuleListComponent} from '../readable-mapping-rule-list/readable-mapping-rule-list.component';
import {EmMappingEngineComponent} from './mapping-engine.component';
import {MatIcon} from '@angular/material/icon';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    EmSpinnerModule,
    EmButtonModule,
    EmMappingRuleListModule,
    EmReadableMappingRuleListComponent,
    EmWarningBoxComponent,
    EmErrorBoxModule,
    EmInfoBoxModule,
    EmInputModule,
    EmIconModule,
    CdkDropList,
    CdkDrag,
    MatIcon,
    CdkDragHandle,
  ],
  declarations: [EmMappingEngineComponent],
  exports: [EmMappingEngineComponent],
})
export class EmMappingEngineModule {}
